var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v("\n    Copyright © "+_vm._s(_vm.getYear)+" Gerapy All Rights Reserved.\n  ")])}]

export { render, staticRenderFns }